
import React from 'react';
import { Menu } from 'antd';
import { observer } from 'mobx-react';
import { LogoutOutlined, ProfileOutlined } from '@ant-design/icons';

import { headerMenuStyle } from './util/Style';

function AccountMenu(props) {

  const showProfileUI = () => {

  }

  return (
    <Menu style={headerMenuStyle}>
      <Menu.Item key="prof" onClick={showProfileUI} icon={<ProfileOutlined />}>
        Your Profile
      </Menu.Item>
      <Menu.Item key="logout" onClick={props.appStore.logout} icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

}

export default observer(AccountMenu);